<template>
  <sm-modal
    :is-visible="showModal"
    :title="title"
    :show-close-icon="showCloseIcon"
    :is-canceble-backdrop="isCancebleBackdrop"
    max-height="600px"
    :is-left-button="showCancelButton"
    :is-right-button="showConfirmButton"
    :left-button-text="cancelButtonText"
    :right-button-text="confirmButtonText"
    @left-button="handleCancel"
    @right-button="handleApply"
    @close="handleClose"
  >
    <template #default>
      <p class="sm-dialog__body">
       {{ text }}
      </p>
    </template>
  </sm-modal>
</template>

<script lang="ts" setup>
// Modules
import { ref, toRefs, onMounted, nextTick } from 'vue';

// Components
import SmModal from '@/components/common/modal/SmModal.vue';

// Types
import { IDialogProps } from '@/types/components/modal';

// Props

const props = withDefaults(
  defineProps<IDialogProps>(),
  {
    title: '',
    showCloseIcon: false,
    text: '',
    showCancelButton: true,
    showConfirmButton: true,
    cancelButtonText: 'Отмена',
    confirmButtonText: 'Ок',
    isCancebleBackdrop: false
  }
);

const {
  title,
  showCloseIcon,
  text,
  showCancelButton,
  showConfirmButton,
  cancelButtonText,
  confirmButtonText
} = toRefs(props);

// Emits

const emits = defineEmits<{
  (e: 'cancel' | 'confirm' | 'close'): void;
}>();

// Data

const showModal = ref<boolean>(false);

// Methods

const cancel = (): void => {
  showModal.value = false;
  
  setTimeout(() => {
    emits('close');
  }, 300);
};

// Handlers
const handleCancel = (): void => {
  emits('cancel');
  cancel();
};
const handleApply = (): void => {
  emits('confirm');
  cancel();
};

const handleClose = (): void => {
  cancel();
};

onMounted(() => {
  nextTick(() => {
    showModal.value = true;
  });
});
</script>